import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  bad: '3-5 hs/semana buscando rutinas en YouTube',
  good: '10 min mirando tu planilla de la semana'
}, {
  bad: 'Siempre los mismos ejercicios sin progreso',
  good: '60+ tácticas y ejercicios con progresión clara'
}, {
  bad: 'Lesiones por mala técnica de tackle',
  good: 'Técnica correcta → articulaciones sanas'
}, {
  bad: 'Sin progresión hacia primera o selección',
  good: '6 tomos con planificación anual de temporada'
}, {
  bad: 'Rendimiento variable sin entender por qué',
  good: 'Sistema de autoevaluación post-partido semana a semana'
}, {
  bad: 'Sin saber estructurar descansos ni nutrición',
  good: 'Guías de nutrición, movilidad y recuperación'
}, {
  bad: 'Cero visibilidad ante seleccionadores',
  good: 'Sistema directo para llamar la atención del cuerpo técnico'
}];
export function Comparison() {
  return <section className="py-14 md:py-24 bg-rugby-green-950 relative" data-id="element-119">
      <div className="container mx-auto px-4" data-id="element-120">
        <div className="max-w-4xl mx-auto" data-id="element-121">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-16" data-id="element-122">
            <h2 className="text-3xl md:text-5xl font-display text-white mb-2 md:mb-4" data-id="element-123">
              LA REALIDAD
            </h2>
            <p className="text-base md:text-xl text-slate-300" data-id="element-124">
              ¿Cuánto cuesta NO tenerlo?
            </p>
          </motion.div>

          <div className="bg-rugby-green-900 rounded-2xl overflow-hidden border border-rugby-green-700 shadow-2xl" data-id="element-125">
            <div className="grid grid-cols-2 text-center border-b border-rugby-green-700" data-id="element-126">
              <div className="p-3 md:p-6 bg-rugby-green-950/50" data-id="element-127">
                <h3 className="font-bold text-slate-400 uppercase tracking-wider text-[11px] md:text-base" data-id="element-128">
                  SIN EL SISTEMA
                </h3>
              </div>
              <div className="p-3 md:p-6 bg-gradient-to-b from-rugby-gold-500/10 to-transparent border-l border-rugby-green-700" data-id="element-129">
                <h3 className="font-bold text-rugby-gold-400 uppercase tracking-wider text-[11px] md:text-base" data-id="element-130">
                  CON EL RUGBY PRO KIT
                </h3>
              </div>
            </div>

            <div className="divide-y divide-rugby-green-800" data-id="element-131">
              {comparisons.map((row, i) => <motion.div key={i} initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.08
            }} whileHover={{
              scale: 1.01
            }} className="grid grid-cols-2 transition-colors hover:bg-rugby-green-800/30" data-id="element-132">
                  <div className="p-3 md:p-6 flex items-start gap-2 md:gap-3 bg-rugby-green-950/30" data-id="element-133">
                    <X size={14} className="text-red-500 flex-shrink-0 mt-0.5 md:w-[18px] md:h-[18px]" data-id="element-134" />
                    <p className="text-slate-400 text-xs md:text-base leading-snug" data-id="element-135">
                      {row.bad}
                    </p>
                  </div>
                  <div className="p-3 md:p-6 flex items-start gap-2 md:gap-3 bg-rugby-green-900 border-l border-rugby-green-700" data-id="element-136">
                    <Check size={14} className="text-rugby-gold-400 flex-shrink-0 mt-0.5 md:w-[18px] md:h-[18px]" data-id="element-137" />
                    <p className="text-white font-medium text-xs md:text-base leading-snug" data-id="element-138">
                      {row.good}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}